<header class="container">
    <a class="logo" routerLink="/" (click)="cleanLeadIndexSession()">
        <img alt="Logo" src="/assets/icons/finstral-contacts-logo.svg">
    </a>

    <fi-header-actions [profileData]="profileData" class="header-actions_component" [adminMandant]="adminMandant"></fi-header-actions>
</header>

<fi-update-banner></fi-update-banner>
